import { StoreState } from "../../store";

const selector = (state: StoreState) => state.city;

export const citySelectors = {};
